'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var browserVersions = exports.browserVersions = require('../../data/browserVersions');


//////////////////
// WEBPACK FOOTER
// ./node_modules/caniuse-lite/dist/unpacker/browserVersions.js
// module id = f/gQ
// module chunks = 81